/* global ES_BUILD */
var radio = require('ES/lib/radio');
var _ = require('ES/lib/lodash');
var Ajax = require('ES/services/Ajax');


module.exports.init = function () {
    var url_to_check = window.location.pathname;

    var original_version = null;
    var is_new_version_available = false;
    if (("undefined" == typeof ES_BUILD) || ("dev" !== ES_BUILD)) { //prevent annoying index loads in dev environment
        Ajax.post(url_to_check, {}, function (err, resp, status) {
            if (status === 200) {
                original_version = resp;
            }
        });
    }

    var checker = setInterval(function () {
        Ajax.post(url_to_check, {}, function (err, resp, status) {
            if (status === 200 && original_version !== null && original_version !== resp) {
                radio('NewAppVersionChecker_new_version_available').broadcast();
                is_new_version_available = true;
                clearInterval(checker);//done with it
            }
        });
    }, 24 * 60 * 60 * 1000);//poll every 24 hours (effectively disable this; it was showing the new version message way too often)

    radio('NewAppVersionChecker_get_status').subscribe(_.debounce(function () {
        if (is_new_version_available) {
            radio('NewAppVersionChecker_new_version_available').broadcast();
        }
    }, 10));
};



// WEBPACK FOOTER //
// ./src/services/NewAppVersionChecker.js